var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.9138,
    height: 32.9138,
    fill: "url(#pattern0_60_346)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_60_346",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_60_346",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_60_346",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA0dJREFUeAHtnL+q1EAUh6/gH/DfI9j4AiKKpQpio2CjtVYp1pxzUiyLZbCys7OxEe0EO7G38i0EOx9AGxG8ZGWKu/fMbOLOmCX5LizhnoRJ5vvNl0mybA4O+IMABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACENgHAieaprkiIg/N7NG2j6o+UNVL+3DgkzuGxWJx3sw+qeqfgZ/fqvp8ckDG7pCZvRwYxJHgzOz+2H2Y1P5V9esugajq60kBGbszqvpzl0DM7OPYfZjU/glkz+KcdSCq+lRV33sfETkzRlalA6mq6pSZLVT1rddvr2ZmL0TkcnEedV2/iZ2vq6o6W/wAnB2UDKRt25N1XX+O9TlVF5EfZnbDOeR8pbkFIiJPUtB7rPuSj77T0twCMbNXPaAfua/Z2P5Xd8pzUOYpzS2QVH83wEdDKXoqTx1g0R0nxlPJOSTVXwKJhEIgkYd4GOI/3CzKJaVw0R1H7OjKGIIh0Qncm1eKDlQM8U9LXhChRiARgwOgzWXqaW9qAG62E/ufQAjkr8bbRsJyuTzXNM2tbd93h/Uicme1Wl1IzOfrVUzqkRGYCsTMrovIt5jWsbqIfFfV26lQCGRgIG3bnt7la9YuFBG5GAuFQAYGUtf1tZgBfesicpdAHAKpq47YKUtE7vUFn9jusXM46xKGDDSEQAp+cYchE7gxxBAMGfSsaXZ36hiCIRjSXa5y2etP+DEuscv4QXWusnzoifun6EAdBD62MYEQSJgPuFP3LMEQDMEQz4xQwxAMwZBgg7fEEAzBEM+MUMMQDMGQYIO3xBAMwRDPjFDDEAzBkGCDt8QQDMEQz4xQwxAMwZBgg7fEEAzBEM+MUMMQDMGQYIO3xBAMwRDPjFDDEAzBkGCDt8SQCRjSNM1V70WRQ2oictMbIF1NVd8NacvZ9lmi7ehLP512/v/LQf/FkFhnqWcgQCAZIOZsgkBy0szQFoFkgJizCQLJSTNDWwSSAWLOJlKBmNmHvpeCbLd+f370crt3ZqlAUr+zY93xG8rU7+MJJPL+lpIDiUBGgJ4KlEAI5Ph5MzVi5rYOQ6ZoSO/Znw0hAAEIQAACEIAABCAAAQhAAAIQKEPgEMIasXoTKclhAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.5240e78dea8d531e1e7a857c58994038.svg";
export { ForwardRef as ReactComponent };